import React from "react";
import { Link } from "react-router-dom";
import TOKEN_LOGO from "assets/img/flokin.jpg";
import MAIN_LOGO from "assets/img/bnb.png";
function Banner() {
  return (
    <div className="container">
      <p className="nft-text-center nft-font-18 text-white nft-pt-60">
        Create, explore, & collect digital art NFTs but also connect with
        artists & collectors
      </p>
      <p className="nft-text-center nft-font-36 text-white">
        Flokinomics NFT Marketplace
      </p>
      <p className="nft-text-center d-flex justify-center items-center mt-4">
        <div>
          <a
            href="https://padd.finance"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="d-none d-lg-block"
              src={TOKEN_LOGO}
              height="200px"
              alt="bg-main-left"
            />
          </a>

          <p className="my-1 mx-5 text-white nft-font-22">$FLOKIN Token</p>
          <p className="mx-5 text-white nft-font-22">5% Fee</p>
        </div>
        <div className="d-none d-lg-block">
          <Link to="/explore" className="explore-btn my-1 mx-5 text-white">
            Explore Marketplace
          </Link>
          <br />
          <a
            href="https://app.bogged.finance/swap?tokenIn=BNB&tokenOut=0x97eA5EfDCb5961A99bA5C96123042507C0210Ec1"
            className="explore-btn my-1 mx-5 text-white"
            target="_blank"
          >
            Buy $FLOKIN
          </a>
        </div>
        <div>
          <img
            className="d-none d-lg-block"
            src={MAIN_LOGO}
            height="200px"
            alt="bg-main-right"
          />
          <p className="my-1 mx-5 text-white nft-font-22">$BNB</p>
          <p className="mx-5 text-white nft-font-22">7.5% Fee</p>
        </div>
      </p>
    </div>
  );
}

export default Banner;
